export const aboutInfo = {
  brandName: '黑料吃瓜爆料中心',
  slogan: '黑料不打烊，吃瓜每一天',
  foundedYear: '2019',
  description: '黑料吃瓜爆料中心成立于2019年，是国内领先的娱乐资讯与吃瓜爆料平台。我们致力于为广大网民提供最新、最全、最真实的娱乐圈、网红圈爆料资讯。平台秉持"真实、客观、独家"的内容理念，已累计发布超过5000篇深度爆料文章，服务超过2000万吃瓜用户。',
  mission: '我们的使命是打破信息壁垒，让每一个普通人都能触及事件真相。在这个信息爆炸的时代，我们坚持做有据可查的真实爆料，拒绝空穴来风的不实传闻。',
  vision: '成为华语地区最具公信力的娱乐爆料平台，构建健康、透明的娱乐资讯生态。',
  stats: [
    { label: '累计爆料', value: '5,000+', icon: 'ri-file-text-line' },
    { label: '活跃用户', value: '2,000万+', icon: 'ri-user-line' },
    { label: '日更新量', value: '50+', icon: 'ri-fire-line' },
    { label: '独家资源', value: '1,200+', icon: 'ri-vip-crown-line' },
  ],
  features: [
    {
      icon: 'ri-shield-check-line',
      title: '真实爆料',
      description: '每一条爆料都经过多重核实，确保信息来源可靠、有据可查。我们拥有专业的调查记者团队和广泛的行业线人网络。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '全网首发',
      description: '深耕行业多年，拥有丰富的独家信息来源。众多重大爆料事件均由本中心率先发布，引领行业风向。',
    },
    {
      icon: 'ri-bar-chart-line',
      title: '实时追踪',
      description: '吃瓜热榜实时滚动更新，确保您不会错过任何一条重磅爆料。所有热点事件持续追踪，直到水落石出。',
    },
    {
      icon: 'ri-user-heart-line',
      title: '用户至上',
      description: '重视每一位用户的投稿和线索，开通多渠道爆料入口。您的每一次提供都可能成为下一个头条新闻。',
    },
  ],
  reviews: [
    {
      name: '资深吃瓜人小王',
      avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20icon%20with%20modern%20minimalist%20design%2C%20neutral%20tone%20background%2C%20simple%20geometric%20style%2C%20warm%20beige%20colors%2C%20clean%20aesthetic&width=120&height=120&seq=avatar-1-2026&orientation=squarish',
      rating: 5,
      content: '吃瓜这么多年，黑料爆料中心是我最信任的平台。信息更新快，内容有深度，不像其他平台全是标题党。真心推荐！',
      date: '2025年6月',
    },
    {
      name: '娱乐记者老张',
      avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20icon%20with%20modern%20minimalist%20design%2C%20neutral%20tone%20background%2C%20simple%20geometric%20style%2C%20warm%20beige%20colors%2C%20clean%20aesthetic&width=120&height=120&seq=avatar-2-2026&orientation=squarish',
      rating: 5,
      content: '作为同行，我对黑料爆料中心的专业性表示respect。他们的调查报道深度和质量在全行业都是顶级的。',
      date: '2025年5月',
    },
    {
      name: '热心网友小李',
      avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20icon%20with%20modern%20minimalist%20design%2C%20neutral%20tone%20background%2C%20simple%20geometric%20style%2C%20warm%20beige%20colors%2C%20clean%20aesthetic&width=120&height=120&seq=avatar-3-2026&orientation=squarish',
      rating: 4,
      content: '每天不来刷一下吃瓜热榜就感觉缺了什么。希望以后能加一个评论区，让大家一起讨论吃瓜。总体很满意！',
      date: '2025年7月',
    },
  ],
  faq: [
    {
      question: '黑料吃瓜爆料中心的信息来源可靠吗？',
      answer: '我们坚持"有据可查"的内容理念。每一条爆料信息在发布前都会经过编辑团队的核实和交叉验证。我们拥有专业的调查记者团队和广泛的行业线人网络，多数独家爆料都附有可追溯的证据材料。同时，我们也欢迎广大网友提供线索，编辑团队会对有价值的线索进行深入调查。',
    },
    {
      question: '如何向黑料吃瓜爆料中心提供线索或投稿？',
      answer: '您可以通过以下方式向我们提供线索：发送邮件至 contact@lymeijialaifu.cn，或在社交媒体平台私信我们的官方账号。我们承诺对所有提供线索的用户信息严格保密。如果您的线索经过核实并发布，将获得相应的线索奖励。',
    },
    {
      question: '黑料吃瓜爆料中心会删除已发布的文章吗？',
      answer: '我们尊重事实和公众的知情权。对于已发布的文章，只有在以下情况下会进行修改或删除：1）文章内容存在事实性错误，经核实后更正；2）司法机关依法要求删除；3）涉及个人隐私保护的必要情况。我们不会因任何形式的公关压力而删除真实报道。',
    },
    {
      question: '平台上的"每日大赛"是什么？',
      answer: '"每日大赛"是我们平台的特色栏目，每日精选当天关注度最高、讨论最热烈的吃瓜话题进行展示。用户可以查看每个话题的详细报道，并通过"投票支持"参与话题热度贡献。每日大赛的排名完全由数据驱动，反映真实的热点趋势。',
    },
    {
      question: '黑料吃瓜爆料中心如何盈利？',
      answer: '黑料吃瓜爆料中心目前主要通过广告收入和品牌合作实现盈利。我们严格区分编辑内容和商业内容，所有广告和商业合作内容均会明确标注。我们坚决抵制"收钱删稿"、"有偿不报"等有损公信力的商业行为。',
    },
  ],
  contact: {
    email: 'contact@lymeijialaifu.cn',
    weibo: '@黑料吃瓜爆料中心',
    wechat: 'heiliaochigua666',
    address: '北京市朝阳区互联网产业园区',
    businessEmail: 'business@lymeijialaifu.cn',
  },
};